<div class="error">
  <p class="waffle" [class.waffle--small]="smallWaffle()">
    {{ inaneWaffle }}
  </p>
  @if (statusCodeDigits().length) {
    <p>
      @for (digit of statusCodeDigits(); track $index) {
        <lib-ball [ball]="digit" />
      }
    </p>
  }
  @if (errorMessage()) {
    <p>{{ errorMessage() }}</p>
  }
  <ng-content />
</div>
